import React, { useState, useEffect} from "react";

import { Link, Navigate, useNavigate} from "react-router";



import Template from "./common/template/Template";
import Loading from "./common/template/Loading";


import UserService from "../services/user.service";
import AuthService from "../services/auth.service";
import FlashMessage from "./common/FlashMessage";

//import RenderPuntosForm from "./Puntos"



import RenderAvgOdo from "./common/visuals/RenderAvgOdo";
import VisualFilterButtons from "./common/visuals/VisualFilterButtons"; 

import { useAuth } from "../context/AuthContext";


const wrapperClass = `w-full h-full p-4 mt-12  mb-4 mx-auto  rounded-lg md:rounded-b-none  shadow-md bg-white`;


const backUrl = process.env.REACT_APP_BACK_URL;
 

export default function MyCompliance () {

  //const user = AuthService.getCurrentUser();
    const { user } = useAuth();

  const navigate = useNavigate();
   
  const [evalId, setEvalId] = useState(false);
  
  const [showModal, setShowModal] = useState(false);

  const [flashMessage, setFlashMessage] = useState(localStorage.getItem('cmx_flashMessage'));
  

  const [error, setError] = useState(false);
  
  const [loading, setLoading] = useState(false);
    //const [message, setMessage] = useState("");  
  
  const [ubicacionId, setUbicacionId] = useState(false);
  const [showUbicacion, setShowUbicacion] = useState(false); 
 
  const UbicacionPicker=({user}) => {
    
          
          const [ubsContent, setUbsContent] = useState(false);
          
      
          useEffect(()=>{

            if(!user){
              navigate('/login');
            }
            
            try{
              
              UserService.getUbs(user).then(
                    
                    (response) => {

                        console.log(response?.data)
        
                        setUbsContent(response?.data);
                        //setContent(response?.data);
                        setLoading(false);                
                          
                        
                    },
        
                    (error) => {
                      const _content =
                        (error?.response && error?.response.data) ||
                        error?.message ||
                        error?.toString();
                      
                      console.log (error)
                      console.log(_content)
                      
                    
                    }
                  
              )

            } catch(error) {

              console.log('catch an error!! ',error)
              if(error.message.includes('401')){
                localStorage.removeItem('user');

              }

            } finally {
              const currentUb = localStorage.getItem('cmx_ubId_selected');
              if(currentUb && !loading){
                console.log('found a currentUb !!- ', currentUb)
                setUbicacionId(currentUb)                
                setShowUbicacion(true)
              }
            }
        
        
          },[user]);
        
          
          const handleSubmit = (event) => {
           
            event.preventDefault();
            //setShowUbicacion(false);
    
            
            const form = event.target;
    
            const formData = new FormData(form);            
            
            const onSubmitUbId = formData.get("selectedUbId");
            
            console.log(onSubmitUbId)
            console.log(formData)
            
            if(onSubmitUbId){
                  
              //localStorage.setItem('cmx_ubId_selected',onSubmitUbId)  
              localStorage.setItem('cmx_ubId_selected',formData.get("selectedUbId")) 
              
              setUbicacionId(onSubmitUbId);
              
            } 
              
            
            
            
          }
    
          const GoButton = ({className}) => {

             
    
              return (   
         
                <button  type="submit" id="submit"
                        className={className + 
                          `h-13 p-2 mx-2 rounded-md border border-white 
                           drop-shadow-md
                          bg-gradient-to-b from-sky-400 to-sky-800 
                              hover:shadow-md hover:bg-sky-600 
                          transition ease-in-out delay-50 hover:-translate-y-1 hover:scale-110 duration-150
                          `                    
                        } 
                        disabled={loading} >
                  
                  <span className="text-white font-semibold text-sm">
                    
                    <svg fill="#FFFFFF" className={`h-4 w-4`} viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        
                          <path d="M0 13.024q0-2.624 1.024-5.056t2.784-4.16 4.16-2.752 5.056-1.056q2.656 0 5.056 1.056t4.16 2.752 2.784 4.16 1.024 5.056q0 3.616-1.984 6.816l7.072 7.040q0.864 0.896 0.864 2.144t-0.864 2.112-2.144 0.864-2.112-0.864l-7.040-7.040q-3.2 1.952-6.816 1.952-2.656 0-5.056-1.024t-4.16-2.784-2.784-4.128-1.024-5.088zM4 13.024q0 2.464 1.216 4.544t3.296 3.264 4.512 1.216q1.824 0 3.488-0.704t2.88-1.92 1.92-2.88 0.736-3.52-0.736-3.52-1.92-2.848-2.88-1.92-3.488-0.736q-2.432 0-4.512 1.216t-3.296 3.296-1.216 4.512z"></path>
                    </svg>
                  </span>
                  
                        
                </button>
                      
              );
            
          }
    
          const SelectDrop = ({ubicaciones}) => {
    
            const [selectedOption, setSelectedOption] = useState(ubicacionId); // Declare a state variable...
            // ...
            const optionClassName = ``;
            const selectClassName = `border border-slate-500 bg-neutral-50 rounded-md p-1 w-1/2 h-10 text-xs font-light shadow-sm`;
    
            const handleChange = (event) =>{
              
               
              setSelectedOption(event.target.value);
              console.log("option changed!")
              console.log(event.target.value)
              
              
            }
    
            return (
              <select
                        name="selectedUbId"
                        value={selectedOption} // ...force the select's value to match the state variable...
                        onChange={e=> handleChange(e)} // ... and update the state variable on any change!
                        className={selectClassName + ``}
                      >
                          <option value="">Seleccione una opción</option>
                        {
              
                          ubicaciones.map((ub) => (
                            <option key={`ub-key-${ub.id}`} 
                              value={ub.id} defaultValue={selectedOption === ub.id}
                            >{ub.name}
                            </option>
              
              
                          ))  
              
                        }
              </select>
            );
            
          }
    
          return (
            
                      
            <div className="flex flex-col relative z-1">
                
                    <p className="text-xs md:text-md mb-0 py-2 font-light">Seleccione una ubicación para empezar: </p>
                    
                    {ubsContent && (   
      
                    
                    <form onSubmit={handleSubmit}>
                      <div className="flex md:max-w-[30vw]">
                        <SelectDrop ubicaciones={ubsContent?.ubicaciones}/>&nbsp;<GoButton />
                      
                      
                      </div>
                      
                        
    
                      
                    </form>
                    
                    )}
                    
                  
                                
            </div>
      
          );
      
          
  }   

  const ShowUbicacion=({ubId}) => {
      
      const [content, setContent] = useState(false);
      const [odoState, setOdoState] = useState('tm');

      const RunButton = ({evalId}) => {

        function handleClick (){
        
          
          setError(false);
          setLoading(true);
          setContent(false); 
          
          setEvalId(evalId);
          console.log(evalId)
          //setInstance(instance);
          
          setShowModal(true);
          
        }
      
        return (
    
    
          <button className="w-4 h-4  rounded-full 
                            opacity-50 hover:opacity-100
                            transtition-all delay-100 duration-300
                            hover:scale-110 mx-2 " 
                  >
            <svg  className="w-4 h-4 " viewBox="0 0 512 512"> 
      
              <path className=" fill-green-400 " d="M256,0C114.625,0,0,114.625,0,256c0,141.374,114.625,256,256,256c141.374,0,256-114.626,256-256
                C512,114.625,397.374,0,256,0z M351.062,258.898l-144,85.945c-1.031,0.626-2.344,0.657-3.406,0.031
                c-1.031-0.594-1.687-1.702-1.687-2.937v-85.946v-85.946c0-1.218,0.656-2.343,1.687-2.938c1.062-0.609,2.375-0.578,3.406,0.031
                l144,85.962c1.031,0.586,1.641,1.718,1.641,2.89C352.703,257.187,352.094,258.297,351.062,258.898z"/>
    
            </svg>
            
            
    
          </button>
    
        );
      }

      function RenderVisuals({visualFilter}){
      
        

        return(
        <div className="max-h-48 w-full overflow-auto drop-shadow-lg rounded-t-md mb-1">

          {content && !loading ? (
              <>
                    {visualFilter === 'tm' && (
                          <RenderAvgOdo result={{average:content.cmx_avg_this_month*100,n:content.num_evals_this_month}} total={100} legend={`% Cumplimiento: `}/>
                    )}
                    {visualFilter === 'all'&&(
                          <RenderAvgOdo result={{average:content.cmx_avg_all*100,n:content.num_evals_all}} total={100} legend={`% Cumplimiento: `}/>

                    )} 
                    {visualFilter === '1Y' && (
                          <RenderAvgOdo result={{average:content.cmx_avg_1y*100,n:content.num_evals_1y}} total={100} legend={`% Cumplimiento: `}/>

                    )}
                    {visualFilter === 'YtD' && (
                          <RenderAvgOdo result={{average:content.cmx_avg_YtD*100,n:content.num_evals_YtD}} total={100} legend={`% Cumplimiento: `}/>

                    )} 
                    {visualFilter === '6m'&&(
                        <RenderAvgOdo result={{average:content.cmx_avg_6m*100,n:content.num_evals_6m}} total={100} legend={`% Cumplimiento: `}/>

                    )} 
                    {visualFilter === '3m'&&(
                        <RenderAvgOdo result={{average:content.cmx_avg_3m*100,n:content.num_evals_3m}} total={100} legend={`% Cumplimiento: `}/>

                    )} 
                    {visualFilter === '30d'&&(
                          <RenderAvgOdo result={{average:content.cmx_avg_30d*100,n:content.num_evals_30d}} total={100} legend={`% Cumplimiento: `}/>

                    )} 
              </>
          

            ) : (

              <Loading />

            )
          }

          </div>
        );
      }

      function RenderList({evals}){      
        
            return(
              <div className="max-h-48 overflow-auto  rounded-t-md mb-1">
                    
                <table id="eval-display" 
                  className="w-full bg-white opacity-90 text-[9px] sm:text-sm shadow-md rounded-sm">
                                
                
                      <thead id="table-evals-display-head" 
                              className="border border-b-zinc-300 " >
                        <tr className="bg-gradient-to-b from-stone-300 to-white  font-semibold sticky top-0 z-40">
                          <td className="p-1"   >
                            id#
                          </td>
                          <td className="p-1"   >
                            Fecha de Inicio Planificada
                          </td>
                          <td className="p-1"  >
                            Lista de Verificación
                          </td> 
                          <td className="p-1">Estado</td>
                          <td className="p-1">Accion</td>
      
                        </tr>
      
                      </thead>
                      <tbody className="text-zinc-600 ">
                
                  
                  {evals.length > 0 ? (

                     evals.map(row => (
                      
                      <tr className="even:bg-gray-50 odd:bg-white" key={'tr-'+row.id} >
                        <td className="p-2" id={'td-id'+row.id}   >
                          { row.id  }
                        </td>
                        <td className="p-2 " id={'td-date_inicio_planif'+row.id}   >
                          { row.date_inicio_planif }
                        </td>
                        <td className="p-2 " id={'td-verif_name'+row.id}   >
                          { row.verif_name }
                        </td> 
                        <td className="p-2">
                        { row.estado }
                        </td>
                        <td className="p-2">
                          {//<RunButton evalId={row.id}/>
                          }
                          <Link to={`/eval?eId=${row.id}`} className={`hover:no-underline mx-2`}>
                            <RunButton/>
                          </Link>
                        </td>    
                      
                      </tr>                       
                
                    ))
                  ) : (
                      <tr className="even:bg-gray-50 odd:bg-white" >
                        <td className="p-2" colSpan={5}>
                          0 registros.
                        </td>                          
                      
                      </tr> 
                  )
                   
                  }
                  </tbody>
                  </table>                
                
              </div>
            );       
          
        
      }

      function RenderListComplete({evals}){      
        
            return(
              <div className="max-h-48 overflow-auto  rounded-t-md mb-1">
                    
                <table id="eval-display" 
                  className="w-full bg-white opacity-90 text-[9px] sm:text-sm shadow-md rounded-sm">
                                
                
                      <thead id="table-evals-display-head" 
                              className="border border-b-zinc-300 " >
                        <tr className="bg-gradient-to-b from-stone-300 to-white  font-semibold sticky top-0 z-40">
                          <td className="p-1"   >
                            id#
                          </td>
                          <td className="p-1"   >
                            Fecha de Inicio Planificada
                          </td>
                          <td className="p-1"  >
                            Lista de Verificación
                          </td> 
                          <td className="p-1">Estado</td>
                          <td className="p-1">Accion</td>
      
                        </tr>
      
                      </thead>
                      <tbody className="text-zinc-600 ">
                
                  
                  {evals.length > 0 ? (

                     evals.map(row => (
                      
                      <tr className="even:bg-gray-50 odd:bg-white" key={'tr-'+row.id} >
                        <td className="p-2" id={'td-id'+row.id}   >
                          { row.id  }
                        </td>
                        <td className="p-2 " id={'td-date_inicio_planif'+row.id}   >
                          { row.date_inicio_planif }
                        </td>
                        <td className="p-2 " id={'td-verif_name'+row.id}   >
                          { row.verif_name }
                        </td> 
                        <td className="p-2">
                        { row.estado }
                        </td>
                        <td className="p-2">
                          {//<RunButton evalId={row.id}/>
                          }
                          <a href={`${backUrl}/reports/eval/${row.id}/${row.read_code}`} rel="noopener noreferrer" target="_blank"
                            className="hover:no-underline transition-all text-base opacity-40 delay-200 duration-500 hover:opacity-100">
                              <button className="w-4 h-4 transition-all delay-100 duration-300 rounded-full opacity-50 hover:opacity-100  hover:scale-110">
                              📋
                              </button> 
                          </a>
                        </td>    
                      
                      </tr>                       
                
                    ))
                  ) : (
                      <tr className="even:bg-gray-50 odd:bg-white" >
                        <td className="p-2" colSpan={5}>
                          0 registros.
                        </td>                          
                      
                      </tr> 
                  )
                   
                  }
                  </tbody>
                  </table>                
                
              </div>
            );       
          
        
      }

      const NewEvalLauncher=({ubId, verifs}) => {   
        
        
          
          //const [newEvalId,setNewEvalId] = useState(false);
          const handleSubmit = (event) => {
           
            event.preventDefault();
    
            setLoading(true);            
            
            const form = event.target;
    
            const formData = new FormData(form);                                  
            
            const onSubmitVerifId = formData.get("verifId");
            console.log(onSubmitVerifId)
            
            try{
              UserService.setEval(ubId,onSubmitVerifId,user).then(

                (response) => {
                  console.log(response)
                  console.log(response.data)
                  setEvalId(response.data.newEvalId)
                  
                   

                  localStorage.setItem('cmx_flashMessage',JSON.stringify({
                    message:'Nueva evaluación iniciada con éxito! (id:'+response.data.newEvalId+').',
                    type:'info'
                  }));

                  //setFlashMessage(temp)
                  //UserService.updateFlash(temp);                

                  navigate('/eval?eId='+response.data.newEvalId)

                }, 
                (error) => {
                  console.log('inside then loop',error)
                }


              )
            } catch (error) {

              console.log(error)
              setFlashMessage({
                'message':'Could not launch  new evaluation',
                'type':'error'
              })
            }
            
            
          }
    
          
    
          const SelectDrop = ({verifs}) => {
    
            const [selectedOption, setSelectedOption] = useState(''); // Declare a state variable...
            // ...
            const optionClassName = ``;
            const selectClassName = `border border-slate-500 shadow-sm bg-neutral-50 rounded-md p-2 w-1/2 h-10 text-xs font-light`;
    
            const handleChange = (event) =>{
              
                     
              setSelectedOption(event.target.value);
             // setVerifId(event.target.value)
              console.log("option changed!")
              console.log(event.target.value)
              
              
            }

            const NewButton = ({className}) => {
    
              return (   
         
                <button  type="submit" id="submit"
                        className={className || 
                          `  rounded-md border border-white
                          shadow-md  px-2 mx-2
                          bg-gradient-to-b
                          
                          ${selectedOption ? (`transition ease-in-out delay-50 hover:-translate-y-1 hover:scale-110 duration-150
                                         from-lime-300 to-lime-600 
                                        hover:shadow-md 
                            
                                        `) : (`
                                          from-neutral-200 to-neutral-400 
                                          
                                        `)}
                          `                    
                        } 
                        disabled={loading || !selectedOption} >
                  
                  <span className={`${selectedOption ? (`text-white`):(`text-neutral-200`)} font-extrabold text-2xl`}>                    
                    +
                  </span>
                  
                        
                </button>
                      
              );
            
            }
    
            return (
              <>
              <select
                        name="verifId"
                        value={selectedOption} // ...force the select's value to match the state variable...
                        onChange={e=> handleChange(e)} // ... and update the state variable on any change!
                        className={selectClassName + ``}

                      >
                          <option value="" >Seleccione...</option>
                        {
              
                          verifs.map((option) => (
                            <option key={`verif-key-${option.id}`} 
                              value={option.id}
                             // selected={selectedOption === option.id}
                            >{option.name}
                            </option>
              
              
                          ))  
              
                        }
              </select>
              <NewButton />
              </>
              
            );
            
          }
    
          return (
            
                      
            <div className="flex md:max-w-[30vw] flex-col relative z-1">                
                                     
                    <form onSubmit={handleSubmit}>
                      
                      <SelectDrop verifs={verifs}/>
                      &nbsp;
                      
                      
                    </form> 
                                
            </div>
      
          );
      
          
      }
      
    
      useEffect(()=>{

        if(!user){
                    
          navigate('/login');
        }

            try{

              UserService.getUbCmx(ubId,user).then(
        
                    (response) => {

                        console.log(response?.data)
        
                        setContent(response?.data);
                        //setContent(response?.data);
                        setLoading(false);                  
                          
                    
                        
                        
                    },
        
                    (error) => {

                      const _content =
                        (error?.response && error?.response.data) ||
                        error?.message ||
                        error?.toString();
                      
                      console.log (error)
                      console.log(_content)
                      // setLoading(false);
                      
                    
                    }
                  
              )

            } catch(error) {
              console.log('catch an error!! ',error)
              navigate('/login')
            }
    
                
        
              
              
        
        
      },[ubId]);
          
    
      return (
            
            <div className="flex flex-col relative z-1">  
                               
                    {content && !loading ? (   
      
                            <>                        
                                <h2 className="text-lg md:text-base mb-0 mt-3 text-zinc-600">Esta viendo: <strong className="text-lime-500">{`${content?.ubicacion.name}`}</strong> <sup className="text-[8px] font-light text-neutral-500">{`[${ubicacionId}]`}</sup> </h2>
                                <h3 className="font-light text-xs text-slate-700 mt-2">Kpi: </h3>
                                <div className="flex md:max-w-[30vw] flex-col border border-slate-600 rounded-md drop-shadow-lg bg-neutral-100" >
                                  <VisualFilterButtons visualState={odoState} setVisualState={setOdoState} />
                                  <RenderVisuals visualFilter={odoState} />
                                </div>
                                
                                
                                <h3 className="font-light text-xs text-slate-700 mt-4">Evaluaciones programadas pendientes:</h3>
                                <div className="flex flex-col border border-slate-600 rounded-md drop-shadow-lg bg-neutral-100" >
                                  <RenderList evals={content.evals_pending}/>
                                </div>
                                <h3 className="font-light text-xs text-slate-700 mt-4">Evaluaciones completadas recientemente:</h3>
                                <div className="flex flex-col border border-slate-600 rounded-md drop-shadow-lg bg-neutral-100" >
                                  <RenderListComplete evals={content.evals_complete}/>
                                </div>
                                
                                <h3 className="font-light text-xs text-slate-700 mt-4">Lanzar nueva evaluación no programada:</h3>
                                
                                <NewEvalLauncher ubId={ubicacionId} verifs={content?.verifs}/>

                            </>

                    ) : (

                      <Loading/>

                    )}
                    
            </div> 
                                
           
      
      );
      
          
  }

   console.log('is there a flashMessage',flashMessage)
    
  return (
    
    <Template>
        <div 
        className={`      `+wrapperClass}>
        
      
        <div className={`flex flex-col 
                    
                    ${showModal && (
                      `hidden`
                    )
                    }

                    
        `} >
          
          <h1 className="text-zinc-600 text-2xl md:text-3xl lg:text-4xl">My Compliance</h1>

              
                {flashMessage && (
                  
                  <FlashMessage flashMessage={flashMessage} setFlashMessage={setFlashMessage}  />
                 
                )}
              
            
              {user ? (


                  <div className="flex flex-col relative z-1">          
                      <div className={`${''}`}>
                          
                          <UbicacionPicker  user={user}/>

                          {showUbicacion &&(     

                              <ShowUbicacion ubId={ubicacionId} />                        
                          
                          )}
                        
                      </div>
                  </div>


              )  : (
                
                <Navigate to="/login" replace={true} state={{ from: "/mycompliance" }} />

              )}
              
                               
        
        </div>   
        
                    
        </div>
      </Template>
  );

  
};


